<template>
  <div>
    <h2>{{ paper.tName }}</h2>
    <p>{{ paper.tDesc }}</p>
    <el-form ref="form" :model="answers" label-width="120px">
      <!-- <el-row v-for="(question, index) in questions" :key="question.tid"> -->
      <el-row v-for="(question, index) in questions" :key="question.question" :id="'question-' + index">
 
        <el-col :span="24" >
          <h3>【单选题】{{ index + 1 }}. {{ question.question }}</h3>
          <!-- <h3 v-else-if="question.tType===4">【多选题】{{ index + 1 }}. {{ question.tExplain }}</h3>
          <h3 v-if="question.tType===3">【问答题】{{ index + 1 }}. {{ question.tExplain }}</h3>
          <h3 v-if="question.tType===2">【判断题】{{ index + 1 }}. {{ question.tExplain }}</h3> -->
        </el-col>
 
        <el-col :span="24">
 
          <!-- 单选 -->
          <el-radio-group v-model="options_id">
            <el-radio v-for="option in question.topicselect" :key="option.id" :label="option.id">
              {{ option.number+'. '+option.option }}
            </el-radio>
          </el-radio-group>
 
          <!-- 多选 -->
          <!-- <el-checkbox-group v-else-if="question.tType === 4" v-model="answers[question.tid]">
            <el-checkbox v-for="option in question.topicSelect" :key="option.tselect" :label="option.tselect">
              {{ option.topics }}
            </el-checkbox>
          </el-checkbox-group> -->
 
          <!-- 问答 -->
          <!-- <el-input style="width: 300px;" v-else-if="question.tType === 3" v-model="answers[question.tid]"></el-input> -->
 
          <!-- 判断 -->
          <!-- <el-radio-group v-else-if="question.tType === 2" v-model="answers[question.tid]">
            <el-radio label="true">正确</el-radio>
            <el-radio label="false">错误</el-radio>
          </el-radio-group> -->
        </el-col>
      </el-row>
    </el-form>
    <el-button style="margin-top: 10px;" type="primary" @click="submitAnswers">提交答案</el-button>
 
    <!-- <DatiKa :questions="questions" :answers="answers"></DatiKa> -->
  </div>
  
</template>

<script>
import DatiKa from './datika.vue'
export default {
  data() {
    return {
      // 试卷基础信息
      paper: {
        tName: 'CSS基础知识测试',
        tDesc: '本测试用于检测CSS基础知识掌握情况'
      },
      //题目，通过axios获取，可以直接添加数组
      questions: [],
      // 双向绑定答案
      answers: {},
      options_id: '',
    }
  },
  components:{
    //注册答题卡子组件
    // DatiKa
  },
  created() {
    //获取题目数据方法
    this.fetchPaper()
  },
  methods: {
    //axios获取后台api接口
    fetchPaper() {
      let data = this.$qs.stringify({

      });
      // console.log(data)
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/question_phone",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data.data)
            this.questions = res.data.data;
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
   
    //提交答案方法
    //将答案格式转化成一个数组，其中有两个属性anid(对应的是题目的tid),daan（选择或输入的答案）
    submitAnswers() {
      const answersArray = []
      for (const [anid] of Object.entries(this.options_id)) {
        answersArray.push({ anid })
      }
      // console.log(answersArray)
      console.log(this.options_id)
    }
  }
}
</script>